import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button, CheckboxGroup, Span } from "@icg360/design-system";

import { Stack } from "components/common/stack";
import { MultiStepFormLayout } from "components/multi-step-form-layout";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";
import { TingContext, type TingContextState } from "pages/offer/ting/ting-flow";

import styles from "./ting-offer.module.scss";

export const Legal = () => {
  const navigate = useNavigate();
  const { state, formNavigate } =
    useMultiStepFormState<TingContextState>(TingContext);
  const [agreed, setAgreed] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      !(
        state?.phone &&
        state?.firstName &&
        state?.lastName &&
        state?.emailAddress &&
        state?.mobile
      )
    ) {
      navigate("../policy-confirmation");
    }
  }, [
    navigate,
    state?.emailAddress,
    state?.firstName,
    state?.lastName,
    state?.phone,
    state?.mobile,
  ]);

  const onAgreeClick = (val) => {
    setAgreed(val);
    setShowError(false);
  };

  const onSubmit = async () => {
    if (!agreed) {
      setShowError(true);
      return;
    }

    formNavigate("../contact-information-confirmation");
  };

  return (
    <MultiStepFormLayout
      step={3}
      totalSteps={4}
      heading="Please read and agree to the user agreement"
      buttonProps={{
        primary: { onPress: onSubmit },
        cancel: { path: state?.from ?? "/" },
        promptOnCancel: true,
        formNavigate,
      }}
    >
      <Stack>
        <div className={styles.terms}>
          {state?.terms?.split("\n").map((paragraph, i) => (
            <p key={i}>
              {i === 0 ? (
                <Button
                  icon="Print"
                  appearance="secondary"
                  size="xs"
                  className={styles.printButtonDS}
                  onPress={print}
                  data-testid="waiver-print"
                />
              ) : null}
              {paragraph}
            </p>
          ))}
        </div>
        <Span className={styles.printHideDS}>
          <CheckboxGroup
            isError={showError}
            errorMessage="Please agree to continue."
            aria-label="I have read and agreed to Ting's user agreement."
          >
            <CheckboxGroup.Checkbox
              onChange={onAgreeClick}
              isInvalid={showError}
            >
              I have read and agreed to Ting&apos;s User Agreement.
            </CheckboxGroup.Checkbox>
          </CheckboxGroup>
        </Span>
      </Stack>
    </MultiStepFormLayout>
  );
};
